var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-modal",
    {
      attrs: { active: _vm.isActive, "can-cancel": false },
      on: { close: _vm.closeCallback }
    },
    [
      _c(
        "sc-modal-card",
        { attrs: { title: "Incluir CNPJ" } },
        [
          _c("template", { attrs: { slot: "body" }, slot: "body" }, [
            _c("p", [
              _vm._v(
                "Informe o CNPJ do centro de distribuição antes de adicionar o certificado digital."
              )
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "warehouse-info" }, [
              _c("p", [_c("strong", [_vm._v("Centro de distribuição")])]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.warehouse_config.warehouse_name))]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Código: ")]),
                _vm._v(" " + _vm._s(_vm.warehouse_config.warehouse_code))
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("CEP: ")]),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm._f("cep")(_vm.warehouse_config.warehouse_zipcode)
                    )
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "cnpj-input" },
              [
                _c(
                  "sc-field",
                  {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "cnpj",
                        expression: "'cnpj'"
                      }
                    ],
                    attrs: {
                      prop: "federal_tax_payer_id",
                      label: "CNPJ",
                      expanded: ""
                    }
                  },
                  [
                    _c("sc-input", {
                      model: {
                        value: _vm.newCnpj,
                        callback: function($$v) {
                          _vm.newCnpj = $$v
                        },
                        expression: "newCnpj"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "template",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("sc-button", {
                attrs: { theme: "default", text: "Voltar", inverted: true },
                on: {
                  click: function() {
                    return _vm.closeCallback()
                  }
                }
              }),
              _vm._v(" "),
              _c("sc-button", {
                attrs: { type: "submit", theme: "primary", text: "Continuar" },
                on: {
                  click: function() {
                    return _vm.continueCallback(_vm.newCnpj)
                  }
                }
              })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22d33891", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22d33891","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/configuration-sefaz/components/sc-add-cnpj-modal/ScAddCnpjModal.vue
// module id = null
// module chunks = 